export enum AutoApplyCouponType {
  FREE_SHIPPING = 'FREE_SHIPPING',
  FREE_GIFT = 'FREE_GIFT',
  FAMILY_DISCOUNT = 'FAMILY_DISCOUNT'
}
